/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRss = createReactComponent("rss", "IconRss", [
  ["path", { d: "M5 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-0" }],
  ["path", { d: "M4 4a16 16 0 0 1 16 16", key: "svg-1" }],
  ["path", { d: "M4 11a9 9 0 0 1 9 9", key: "svg-2" }]
]);

export { IconRss as default };
//# sourceMappingURL=IconRss.js.map
